import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewNotificacionesAutomaticas = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'notificaciones_automaticas',
        name: 'Notificaciones Automáticas',
        component: ViewNotificacionesAutomaticas,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
